import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-743d880c")

_pushScopeId("data-v-743d880c")
const _hoisted_1 = { class: "shell info-container info-padding" }
const _hoisted_2 = { class: "info-label-title" }
const _hoisted_3 = { class: "info-label-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "height10px" }, null, -1)
const _hoisted_7 = { class: "detail-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bread_crumb = _resolveComponent("bread-crumb")
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_bread_crumb, {
      headers: _ctx.navHeaders,
      baseLabel: _ctx.$wordList.TabelPersonKeyInHtmlUser,
      basePath: _ctx.basePath
    }, null, 8, ["headers", "baseLabel", "basePath"]),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infoKey, (item) => {
        return (_openBlock(), _createBlock("div", {
          key: item.key,
          class: "info-item"
        }, [
          _createVNode("label", _hoisted_2, _toDisplayString(item.label) + ":", 1),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.info[item.key]?_ctx.info[item.key]:'--'), 1)
        ]))
      }), 128)),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode("b", _hoisted_7, _toDisplayString(_ctx.$wordList.OrderDevice), 1),
      _createVNode(_component_list, {
        headers: _ctx.deviceHeaders,
        showCheck: false,
        action: false,
        requestData: _ctx.devRequestData
      }, null, 8, ["headers", "requestData"])
    ])
  ]))
})